import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { displayDateWithTime } from "./displayDateWithTime";
import { momentLocaleFor } from "./i18nFormatters";

export const useDisplayDateWithTime = () => {
  const { t, i18n } = useTranslation();
  const locale = momentLocaleFor(i18n.language);
  return useCallback((value: string) => displayDateWithTime(value, t("at"), locale), [t, locale]);
};
